import { APP_ENV } from './constants.ts';

export const focusRing = [
    // base
    'outline-solid outline-offset-2 outline-0 focus-visible:outline-2',
    // outline color
    'outline-blue-500',
];

// Lang

export function isDev() {
    return process.env.NODE_ENV === 'development' || APP_ENV !== 'production';
}
